export class Objects
{
  static copyTo<S,T>( source:S, target:T )
  {
    Object.assign( target, source );
  }

  
}